module.exports = __webpack_public_path__ + "img/app-academy-tutor-4.e0b954f9.png";